import { Beneficiary, MerchantAccountGroup } from '@/classes/models'

export default class Remittance {
  /**
   * Create new remittance and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map order to Beneficiary
    if (typeof this.beneficiary !== 'undefined') {
      this.beneficiary = new Beneficiary(this.beneficiary)
    }

    // Map order to MerchantAccountGroup
    if (typeof this.MerchantAccount !== 'undefined') {
      this.MerchantAccount = new MerchantAccountGroup(this.MerchantAccount)
    }
  }

  /**
   * @return {Date}
   */
  get startDate () {
    return this._startDate
  }

  /**
   * @param {string} value
   */
  set startDate (value) {
    this._startDate = value ? new Date(value) : null
  }

  /**
   * @return {Date}
   */
  get nextPaymentDate () {
    return this._nextPaymentDate
  }

  /**
   * @param {string} value
   */
  set nextPaymentDate (value) {
    this._nextPaymentDate = value ? new Date(value) : null
  }

  /**
   * @return {Date}
   */
  get nextScheduleDate () {
    return this._nextScheduleDate
  }

  /**
   * @param {string} value
   */
  set nextScheduleDate (value) {
    this._nextScheduleDate = value ? new Date(value) : null
  }
}
